module.exports = __webpack_public_path__ + "media/components/weather-icon/static/daylightshowers-012c8d25bf61de38e550adad552b3548.svg";